import type { PrismNewRequest } from './prism-new-legacy-maps';

/**
 * RAG request-side differences (prism-new `rag-v1` DTOs vs the old gateway), keyed like
 * prism-new-endpoints.ts. The response data already matches what the knowledge-base page reads.
 */
export const RAG_REQUEST_FIXES: Record<string, (request: PrismNewRequest) => void> = {
  // The gateway listed every feature; prism-new pages them (default 50).
  // ponytail: one 100-row page (prism-new's max); loop pages if a catalogue ever outgrows it.
  'GET /rag/features': ({ params }) => {
    params['limit'] ??= 100;
  },
  // The page filters options by `product_feature_id` (a features.id), which the gateway read as
  // `feature_id` with active options only; prism-new drops the unknown key and lists every option.
  'GET /rag/feature-options': ({ params }) => {
    if (params['product_feature_id'] == null) return;
    params['feature_id'] ??= params['product_feature_id'];
    params['is_active'] ??= 1;
    delete params['product_feature_id'];
  },
  // No document was ever PENDING (the gateway just matched nothing); prism-new rejects the value
  // (400). UPLOADED is the not-yet-embedded state it has instead.
  'GET /rag/documents': ({ params }) => {
    if (params['status'] === 'PENDING') params['status'] = 'UPLOADED';
  },
};
